"use strict"

import {observable, action} from "mobx"

class PatientDetailActionsStore {
	@observable isOpen = false

	@action open() {
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}
}

var singleton = new PatientDetailActionsStore()
export default singleton
